import artboard5 from "../assets/artboard-5.webp";
import artboard2 from "../assets/artboard-2.webp";
import artboard3 from "../assets/artboard-3.webp";
import artboard4 from "../assets/artboard-4.webp";

const aroundWhisky = [
  {
    image: artboard2,
    name: "scotch",
    info: "To be called Scotch(like us), the whisky must be made entirely in Scotland.A Scotch Whisky has to be made from malted barley or grain and aged in oak casks no bigger than 700 litres, for no less than three years.",
  },
  {
    image: artboard3,
    name: "irish",
    info: "This is any whiskey made in the Republic of Ireland or Northern Ireland.Any malted cereal grains can be used in any proportion.Like Scotch, it must be aged in wooden casks for at least three years.",
  },
  {
    image: artboard4,
    name: "japanese",
    info: "Japanese whisky is usually made in the same way as Scotch whisky.It's been produced since the 1920s, but it’s only become widely available outside of Japan in the last decade.",
  },
  {
    image: artboard5,
    name: "american",
    info: "These can be made from any cereal grain including rye, corn, barley and wheat. Around a third of American whiskies are bourbons. Other types include Tennessee Whisky, Rye and whisky liqueurs.",
  },
];

export default aroundWhisky;
